<template>
  <ValidationObserver ref="overviewPage" id="overviewPage" name="overviewPage">
    <div v-if="loadingDocuments" class="text-center font-size-h2">
      <b-spinner variant="primary"></b-spinner>
    </div>

    <div v-if="boxWidgetLink">
      <iframe :src="boxWidgetLink" width="1200" height="1000" frameborder="0"></iframe>
    </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>

export default {
  name: "DocumentsPage",

  components: {},

  props: {
    folderSharedLink: String,
    loadingDocuments: Boolean
  },

  data() {
    return {
    };
  },

  computed: {
    boxWidgetLink() {
      if(this.folderSharedLink) {
        return `https://dkg.app.box.com/embed/s/${this.folderSharedLink}?view=list&sortColumn=date&sortDirection=DESC&hideHubsGallery=true&showItemFeedActions=false&showParentPath=false`;
      }
      return null;
    }
  },

  methods: {
  }
};
</script>
